import { useEffect, useState } from 'react';
import { A02, A02Output } from 'api/U005';

export interface Notification {
  id: number;
  publishedAt: Date;
  title: string;
  notice: string;
  file1?: string;
  file2?: string;
  file3?: string;
  file4?: string;
  file5?: string;
}

export function useGetNotifications(
  auditionId: string,
  lang: string
): [Notification[], boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(true);
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [err, setError] = useState<Error | null>(null);

  const fetchNotifications = async (
    auditionId: string,
    lang: string,
    cancellation: AbortSignal
  ) => {
    const json = (await A02(auditionId, lang, cancellation)) as A02Output;
    return json.notifications.map((obj) => {
      return {
        id: obj.id,
        publishedAt: new Date(obj.published_at),
        title: obj.title,
        notice: obj.notice,
        file1: obj.file1,
        file2: obj.file2,
        file3: obj.file3,
        file4: obj.file4,
        file5: obj.file5,
      } as Notification;
    });
  };

  useEffect(() => {
    const controller = new AbortController();
    const cancellation = controller.signal;
    async function fetch() {
      try {
        setLoading(true);
        setError(null);
        const notifications = await fetchNotifications(auditionId, lang, cancellation);
        setNotifications(notifications);
      } catch (err) {
        console.error(err);
        setError(err instanceof Error ? err : new Error(`unknown error. ${err}`));
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      controller.abort();
    };
  }, [auditionId, lang]);

  return [notifications, loading, err];
}
